import { AuthenticationService } from 'apps/epims/mrsoftepims/src/app/services/auth.service';
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  AcquisitionTypeDto,
  CurrencyDto,
  LandTitleDto,
  MeasureDto,
  SubSubGroupDto,
  SubGroupDto,
  GroupDto,
} from "@cradua/data";
import Swal from "sweetalert2";
import { AcquisitionRole } from "../../aquisition-role.enum";
import  { AcquisitionService } from '../../services/acquisition.service';


@Component({
  selector: 'cradua-land-title-report',
  templateUrl: './land-title-report.component.html',
  styleUrls: ['./land-title-report.component.scss']
})
export class LandTitleReportComponent implements OnInit {
  @Input() activities: any[];
  @Input() landTitles: LandTitleDto[];
  @Input() subSubGroups: SubSubGroupDto[];
  @Input() subGroups: SubGroupDto[];
  @Input() groups: GroupDto[];
  @Input() measures: MeasureDto[];
  @Input() currencies: CurrencyDto[];
  @Input() acquisitionTypes: AcquisitionTypeDto[];

  @Input() searchLandTitle: LandTitleDto[];

  @Output() emitEvent = new EventEmitter<any>();
  @Output() dispatchView = new EventEmitter<any>();
  isToggle = false;
  listView = false;
  gridView = true;
  selectedActivity: any;
  user;
  SubscriberName;
  reportRef;

  constructor(
    public authServ: AuthenticationService,
    private acquisitionService: AcquisitionService,
  ) {}

  ngOnInit() {
    if(this.authServ.getUser() != null)
    {
      this.user = this.authServ.getUser();
      this.SubscriberName = this.user.SubscriberName;
    }
    this.selectedActivity = this.activities.find(item => item?.activityName === AcquisitionRole.VIEWACQUISITION &&
      item?.activitySelectedValue !== AcquisitionRole.NOACCESS);

    if(this.landTitles != null && this.landTitles.length) {
      this.isToggle = true;
    }

    this.acquisitionService.getReportRef().subscribe(res => {
      this.reportRef = res;
    });
  }


  protected findById = <T>(id: string) =>
    (fieldName: T) => fieldName["id"] === id;

  getGroupName(id: string) {
    const found = this.groups.find(this.findById<GroupDto>(id))
      return found ? found.GroupName: null;
  }

  getSubGroupName(id: string) {
   const found = this.subGroups.find(this.findById<SubGroupDto>(id))
        return found ? found.SubGroupName : null;
  }

  getSubSubGroupName(id: string) {
    const found = this.subSubGroups.find(this.findById<SubSubGroupDto>(id))
      return found ? found.SubSubGroupName : null;
  }

  getCurrencyCode(id: string) {
     const found = this.currencies.find(this.findById<CurrencyDto>(id));
      return found ? found.CurrencyName : null;
  }

  getAcquisitionTypeName(id: string) {
    const found = this.acquisitionTypes.find(this.findById<AcquisitionTypeDto>(id));
     return found ? found.AcquisitionTypeName : null;
  }

  getMeasureName(id: string) {
  const found = this.measures.find(this.findById<MeasureDto>(id));
       return found ? found.MeasureName : null;
  }

  getTotalCost(totalCost: number) {
    return totalCost ? totalCost : 0;
  }

  onView(value) {
    if(!this.selectedActivity) {
      Swal.fire(
        'Warning!',

        'Access Denied, you are not allow to access this page',
        'warning'
      );
      return;
    }
    this.dispatchView.emit(value);
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

}
